var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 28,
    rx: 4.5,
    fill: "white",
    stroke: "#DCE0E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 22.375L18.125 17.125M19.875 12.75C19.875 13.5543 19.7166 14.3508 19.4088 15.0939C19.101 15.8371 18.6498 16.5123 18.081 17.081C17.5123 17.6498 16.8371 18.101 16.0939 18.4088C15.3508 18.7166 14.5543 18.875 13.75 18.875C12.9457 18.875 12.1492 18.7166 11.4061 18.4088C10.6629 18.101 9.98773 17.6498 9.41897 17.081C8.85021 16.5123 8.39905 15.8371 8.09124 15.0939C7.78343 14.3508 7.625 13.5543 7.625 12.75C7.625 11.1255 8.27031 9.56763 9.41897 8.41897C10.5676 7.27031 12.1255 6.625 13.75 6.625C15.3745 6.625 16.9324 7.27031 18.081 8.41897C19.2297 9.56763 19.875 11.1255 19.875 12.75Z",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a16ffb1254aa6c5c82d7b21869e4208d.svg";
export { ForwardRef as ReactComponent };